import React, { useMemo } from "react";
import styles from "./QuotaConsumptions.module.css";
import { roundTo } from "../../utils";
import { translate, translateDate } from "../../providers";
import { ProgressBar } from "../progress";
import { CustomIconButton } from "../buttons";
import { icon } from "../icon-component";

const QuotaConsumption = ({ addTooltip, consumption, onClick, onExtendQuota, title = "" }) => {
	const percentage = useMemo(
		() => (consumption.totalLimit === 0 ? 1 : consumption.consumed / consumption.totalLimit),
		[consumption]
	);
	const handleClick = () => {
		onClick(consumption);
	};
	return (
		<div>
			<div className={styles.container}>
				<div>
					<div className={styles.title}>
						<span>{title}</span>
						<span>
							{translate("common:company.quotas.consumption-side-panel.consumption", {
								consumed: roundTo(consumption.consumed / 1000000, 1),
								total: roundTo(consumption.totalLimit / 1000000, 1),
							})}
							({roundTo(percentage * 100, 0)}%)
						</span>
					</div>
					<ProgressBar className={styles.progressBar} color="var(--color-blue)" value={percentage} />
				</div>
				{typeof onExtendQuota === "function" && (
					<CustomIconButton
						icon={icon.faPlus}
						size="xs"
						tooltip={addTooltip}
						variant="outlined"
						onClick={handleClick}
					/>
				)}
			</div>
			{consumption?.extension && consumption?.extension?.tokenExtensions > 0 && (
				<div className={styles.extensionText}>
					<span>
						{translate("common:company.quotas.consumption-side-panel.extention", {
							tokenCount: roundTo(consumption?.extension?.tokenExtensions / 1000000, 1),
						})}
					</span>
					<span>{translateDate(consumption?.extension?.validUntil)}</span>
				</div>
			)}
		</div>
	);
};

export default QuotaConsumption;
